var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 272,
    viewBox: "0 0 48 272",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.6654 1.44214C35.1248 12.5944 25.6637 23.7409 16.8932 35.5149C10.69 43.8425 4.10001 52.5059 1.2247 62.6654C-1.98849 74.0186 30.2263 66.8455 36.1265 66.5203C61.9178 65.0988 30.016 100.605 25.3907 107.433C17.4047 119.221 12.6799 131.882 11.9191 146.148C11.4872 154.246 16.5731 155.651 23.857 154.687C28.5001 154.072 37.2808 150.334 41.7639 152.656C48.7435 156.27 31.9666 172.346 30.4063 174.21C22.8087 183.287 14.7843 193.132 9.51491 203.806C6.4395 210.036 6.65326 214.837 14.4476 213.92C22.7214 212.947 30.6469 209.087 39.111 209.775C48.2327 210.517 45.4023 221.845 42.8416 227.682C38.7666 236.971 33.4634 245.76 29.1627 254.957C26.8731 259.853 25.3663 265.368 23.028 270.045",
    stroke: "#191713",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine);
export default __webpack_public_path__ + "static/media/line.643169b2b449e8d5e2c6518a696ff2dd.svg";
export { ForwardRef as ReactComponent };